(function () {
  'use strict';

  function parseHTML(str) {
    var div = document.createElement('div');
    div.innerHTML = str;
    return div;
  }

  function PageCollectionGrid(section) {
    this.section = section;
    this.root = section.querySelector('[data-page-collection-root]');
    if (!this.root || this.root.dataset.pageCollectionInit === 'true') return;
    this.root.dataset.pageCollectionInit = 'true';

    this.collectionUrl = this.root.dataset.collectionUrl;
    this.sourceSectionId = this.root.dataset.collectionSectionId || 'main';
    this.usePageTitle = this.root.dataset.usePageTitle === 'true';
    this.pageTitle = this.root.dataset.pageTitle || '';
    this.errorText = this.root.dataset.errorText || '';
    this.loadingText = this.root.dataset.loadingText || 'Loading…';
    this.mixedUrls = (this.root.dataset.mixedCollectionUrls || '')
      .split('|')
      .filter(function (url) {
        return url;
      });
    this.shellCollectionUrl = this.root.dataset.shellCollectionUrl || this.collectionUrl;
    this.initialMixed = this.root.dataset.initialMixed === 'true' && this.mixedUrls.length > 1;
    this.mixedMode = this.initialMixed;

    if (!this.collectionUrl && !this.mixedUrls.length) return;
    if (this.initialMixed) {
      this.collectionUrl = this.shellCollectionUrl;
    }

    this.params = '';
    this.page = 1;
    this.requestToken = 0;
    this.resolvedSectionId = '';

    this.section._pageCollectionGridInstance = this;
    this.bindCollectionSwitcher();
    this.loadInitial();
  }

  PageCollectionGrid.prototype.rememberSectionId = function (template) {
    if (!template || this.resolvedSectionId) return;
    var id = template.getAttribute('data-section-id');
    if (id) this.resolvedSectionId = id;
  };

  PageCollectionGrid.prototype.wrapTemplate = function (doc) {
    var template = doc.querySelector('.section-collection-template');
    if (!template) return null;
    this.rememberSectionId(template);
    var wrap = document.createElement('div');
    wrap.appendChild(template);
    return wrap;
  };

  PageCollectionGrid.prototype.buildPageUrl = function (params, page) {
    var qs = [];
    if (params) qs.push(params);
    if (page && page > 1) qs.push('page=' + page);
    return qs.length ? this.collectionUrl + '?' + qs.join('&') : this.collectionUrl;
  };

  PageCollectionGrid.prototype.buildSectionUrl = function (params, page) {
    return this.buildSectionUrlForCollection(this.collectionUrl, params, page);
  };

  PageCollectionGrid.prototype.buildSectionUrlForCollection = function (collectionUrl, params, page) {
    var sectionId = this.resolvedSectionId || this.sourceSectionId;
    var url = collectionUrl + '?section_id=' + encodeURIComponent(sectionId);
    if (params) url += '&' + params;
    if (page && page > 1) url += '&page=' + page;
    return url;
  };

  PageCollectionGrid.prototype.fetchDocument = function (url) {
    return fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('Request failed');
      return res.text();
    });
  };

  PageCollectionGrid.prototype.fetchFullPage = function (params, page) {
    var self = this;
    return this.fetchDocument(this.buildPageUrl(params, page))
      .then(parseHTML)
      .then(function (doc) {
        var wrap = self.wrapTemplate(doc);
        if (!wrap) throw new Error('No collection template');
        return wrap;
      });
  };

  PageCollectionGrid.prototype.fetchScope = function (params, page) {
    var self = this;
    return this.fetchDocument(this.buildSectionUrl(params, page))
      .then(parseHTML)
      .then(function (scope) {
        var template = scope.querySelector('.section-collection-template');
        if (template) {
          self.rememberSectionId(template);
          return scope;
        }
        throw new Error('Empty section response');
      })
      .catch(function () {
        return self.fetchFullPage(params, page);
      });
  };

  PageCollectionGrid.prototype.getInitialParamsFromUrl = function () {
    var params = new URLSearchParams(window.location.search);
    var filterParams = new URLSearchParams();

    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 || key === 'sort_by') {
        filterParams.append(key, value);
      }
    });

    return filterParams.toString();
  };

  PageCollectionGrid.prototype.applyUrlParamsToFilters = function () {
    if (!this.template) return;

    var params = new URLSearchParams(window.location.search);
    var self = this;

    params.forEach(function (value, key) {
      if (key.indexOf('filter.') !== 0) return;

      self.template
        .querySelectorAll('.filter-group-display__list-item_checkbox[name="' + key + '"]')
        .forEach(function (cb) {
          if (cb.value === value) {
            cb.checked = true;
            return;
          }
          try {
            if (decodeURIComponent(cb.value) === value) cb.checked = true;
          } catch (e) {
            /* ignore malformed values */
          }
        });
    });
  };

  PageCollectionGrid.prototype.getScrollOffset = function () {
    var header = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    );
    return (isNaN(header) ? 72 : header) + 12;
  };

  PageCollectionGrid.prototype.scrollToGrid = function () {
    if (!this.root) return;

    var offset = this.getScrollOffset();
    if (window.AT && typeof window.AT.scrollTo === 'function') {
      window.AT.scrollTo(this.root, 600, offset);
      return;
    }

    var top = window.pageYOffset + this.root.getBoundingClientRect().top - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  PageCollectionGrid.prototype.showLoading = function () {
    this.root.innerHTML =
      '<div class="page-collection-grid__loading" data-page-collection-loading>' +
      '<span class="page-collection-grid__spinner" aria-hidden="true"></span>' +
      '<span>' + this.loadingText + '</span>' +
      '</div>';
    this.template = null;
  };

  PageCollectionGrid.prototype.loadInitial = function (options) {
    if (this.initialMixed && this.mixedMode) {
      this.loadMixed(options);
      return;
    }

    var self = this;
    options = options || {};
    this.mixedMode = false;
    this.page = 1;
    this.showLoading();
    this.fetchScope(this.getInitialParamsFromUrl(), 1)
      .then(function (scope) {
        self.render(scope);
        if (options.scrollToGrid) {
          self.scrollToGrid();
        }
      })
      .catch(function () {
        self.renderError();
      });
  };

  PageCollectionGrid.prototype.fetchProductItemsFromUrl = function (collectionUrl) {
    var self = this;
    return this.fetchDocument(this.buildSectionUrlForCollection(collectionUrl, '', 1))
      .then(parseHTML)
      .then(function (doc) {
        var grid = doc.querySelector('#main-collection-product-grid');
        if (!grid) return [];
        return Array.prototype.slice.call(grid.children);
      })
      .catch(function () {
        return [];
      });
  };

  PageCollectionGrid.prototype.getProductKey = function (item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : href.split('?')[0];
  };

  PageCollectionGrid.prototype.mergeProductGrids = function (itemArrays) {
    if (!this.gridContainer) return;

    var seen = {};
    var merged = [];

    itemArrays.forEach(function (items) {
      items.forEach(function (item) {
        var key = this.getProductKey(item);
        if (!key || seen[key]) return;
        seen[key] = true;
        merged.push(item.cloneNode(true));
      }, this);
    }, this);

    this.gridContainer.innerHTML = '';

    if (!merged.length) {
      this.gridContainer.innerHTML =
        '<div class="text-left"><p>' + this.errorText + '</p></div>';
      return;
    }

    merged.forEach(
      function (node) {
        this.gridContainer.appendChild(node);
      }.bind(this)
    );
  };

  PageCollectionGrid.prototype.setMixedViewState = function (isMixed) {
    this.mixedMode = isMixed;
    this.section.classList.toggle('is-mixed-view', isMixed);
    if (!this.template) return;

    this.template.classList.toggle('is-mixed-collection-view', isMixed);

    this.template.querySelectorAll('.pagination-container, .btn-load-infinite').forEach(function (el) {
      el.style.display = isMixed ? 'none' : '';
    });

    this.template.querySelectorAll('.collection-filters, #collection-sidebar').forEach(function (el) {
      el.style.display = isMixed ? 'none' : '';
    });
  };

  PageCollectionGrid.prototype.loadMixed = function (options) {
    var self = this;
    options = options || {};
    this.page = 1;
    this.collectionUrl = this.shellCollectionUrl || this.mixedUrls[0];
    this.showLoading();
    this.setMixedViewState(true);

    this.fetchScope('', 1)
      .then(function (scope) {
        self.render(scope);
        self.setMixedViewState(true);
        return Promise.all(
          self.mixedUrls.map(function (url) {
            return self.fetchProductItemsFromUrl(url);
          })
        );
      })
      .then(function (itemArrays) {
        self.mergeProductGrids(itemArrays);
        self.updateSwitcherActiveState();
        if (options.scrollToGrid) {
          self.scrollToGrid();
        }
      })
      .catch(function () {
        self.renderError();
      });
  };

  PageCollectionGrid.prototype.renderError = function () {
    this.root.innerHTML =
      '<p class="page-collection-grid__empty">' + this.errorText + '</p>';
  };

  PageCollectionGrid.prototype.applyPageTitle = function (template) {
    if (!this.usePageTitle || !this.pageTitle) return;
    var heading = template.querySelector('.collection-template_title h1');
    if (heading) heading.textContent = this.pageTitle;
  };

  PageCollectionGrid.prototype.render = function (scope) {
    var template = scope.querySelector('.section-collection-template');
    if (!template) {
      this.renderError();
      return;
    }

    template.removeAttribute('data-section-type');
    template.removeAttribute('id');

    this.root.innerHTML = '';
    this.root.appendChild(template);
    this.template = template;

    this.applyPageTitle(template);
    this.applyUrlParamsToFilters();

    this.gridContainer = template.querySelector('#main-collection-product-grid');
    this.setMixedViewState(this.mixedMode);
    this.bindFilters();
    this.bindSort();
    this.bindGridView();
    this.bindMobileDrawer();
    this.bindMaxlist();
    this.bindPagination();

    if (window.CollectionFiltersEnhancements) {
      window.CollectionFiltersEnhancements.init(this.template);
    }

    this.params = this.collectParams();
    this.updateSwitcherActiveState();
  };

  PageCollectionGrid.prototype.collectParams = function () {
    var params = new URLSearchParams();
    var filterPanel = this.template && this.template.querySelector('#main-collection-filters');

    if (filterPanel && window.CollectionFiltersEnhancements) {
      window.CollectionFiltersEnhancements.syncActiveFormToMain(filterPanel);
      var query = window.CollectionFiltersEnhancements.getFilterQuery(filterPanel);
      if (query) {
        new URLSearchParams(query).forEach(function (value, key) {
          params.append(key, value);
        });
      }
    } else if (this.template) {
      var seen = {};
      this.template
        .querySelectorAll('.group-type-list-wrapper .filter-group-display__list-item_checkbox:checked, #collection-filters-form .filter-group-display__list-item_checkbox:checked')
        .forEach(function (cb) {
          if (!cb.name) return;
          var key = cb.name + '=' + cb.value;
          if (seen[key]) return;
          seen[key] = true;
          params.append(cb.name, cb.value);
        });

      var priceWrap = this.template.querySelector('.group-type-list-wrapper .range-slider, .main-range-slider');
      if (priceWrap) {
        var min = priceWrap.querySelector('.field__input-min');
        var max = priceWrap.querySelector('.field__input-max');
        if (min && min.name && min.value !== '') params.append(min.name, min.value);
        if (max && max.name && max.value !== '') params.append(max.name, max.value);
      }
    }

    if (this.template) {
      var sort = this.template.querySelector('.select-sort-by');
      if (sort && sort.value) params.append('sort_by', sort.value);
    }

    return params.toString();
  };

  PageCollectionGrid.prototype.applyFilters = function (page) {
    if (this.mixedMode) return;

    var self = this;
    var filterPanel = this.template && this.template.querySelector('#main-collection-filters');
    if (filterPanel && window.CollectionFiltersEnhancements) {
      window.CollectionFiltersEnhancements.syncActiveFormToMain(filterPanel);
    }
    var params = this.collectParams();
    var token = ++this.requestToken;
    var targetPage = page || 1;

    this.section.classList.add('is-loading');

    this.fetchScope(params, targetPage)
      .then(function (scope) {
        if (token !== self.requestToken) return;
        self.render(scope);
        self.section.classList.remove('is-loading');
        self.scrollToGrid();
      })
      .catch(function () {
        if (token !== self.requestToken) return;
        self.section.classList.remove('is-loading');
      });
  };

  PageCollectionGrid.prototype.bindFilters = function () {
    var self = this;
    if (!this.template) return;

    this.template
      .querySelectorAll('.filter-group-display__list-item_checkbox')
      .forEach(function (cb) {
        cb.addEventListener('change', function () {
          self.applyFilters(1);
        });
      });

    var filterPanel = this.template.querySelector('#main-collection-filters');
    if (filterPanel) {
      filterPanel.addEventListener('collection-filters:apply', function () {
        self.applyFilters(1);
      });
    }
  };

  PageCollectionGrid.prototype.bindSort = function () {
    var self = this;
    if (!this.template) return;

    this.template.querySelectorAll('.select-sort-by').forEach(function (select) {
      select.addEventListener('change', function () {
        self.template.querySelectorAll('.select-sort-by').forEach(function (other) {
          other.value = select.value;
        });
        self.applyFilters(1);
      });
    });
  };

  PageCollectionGrid.prototype.bindGridView = function () {
    var self = this;
    var container = this.template && this.template.querySelector('#collection-product-grid-container');
    if (!container) return;

    this.template.querySelectorAll('.grid-list .grid').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var gridClass = btn.getAttribute('data-grid');
        if (!gridClass) return;
        container.className = gridClass;
        self.persistGridView(gridClass);
      });
    });
  };

  PageCollectionGrid.prototype.persistGridView = function (gridClass) {
    if (!window.Shopify || !window.Shopify.routes) return;
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;'
      },
      body: JSON.stringify({ attributes: { grid_view: gridClass } })
    }).catch(function () {});
  };

  PageCollectionGrid.prototype.bindMobileDrawer = function () {
    if (!this.template) return;

    var open = this.template.querySelector('.mobile-filter-icon');
    var close = this.template.querySelector('.js-sidebar-close');
    if (open) {
      open.addEventListener('click', function () {
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('active-sidebar');
      });
    }
    if (close) {
      close.addEventListener('click', function () {
        document.documentElement.classList.remove('overflow-hidden');
        document.body.classList.remove('active-sidebar');
      });
    }
  };

  PageCollectionGrid.prototype.bindMaxlist = function () {
    if (!this.template) return;

    this.template.querySelectorAll('.maxlist-more').forEach(function (el) {
      el.addEventListener('click', function () {
        var box = this.closest('.filter-maxlist');
        this.classList.add('d-none');
        this.closest('.filter-group_inner').classList.add('maxlist-more-active');
        box.querySelector('.maxlist-less').classList.remove('d-none');
      });
    });
    this.template.querySelectorAll('.maxlist-less').forEach(function (el) {
      el.addEventListener('click', function () {
        var box = this.closest('.filter-maxlist');
        this.classList.add('d-none');
        this.closest('.filter-group_inner').classList.remove('maxlist-more-active');
        box.querySelector('.maxlist-more').classList.remove('d-none');
      });
    });
  };

  PageCollectionGrid.prototype.bindPagination = function () {
    var self = this;
    if (!this.template) return;

    this.template.querySelectorAll('.pagination a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href) return;

        var page = 1;
        try {
          var url = new URL(href, self.collectionUrl);
          page = parseInt(url.searchParams.get('page') || '1', 10);
        } catch (err) {
          var match = href.match(/[?&]page=(\d+)/);
          if (match) page = parseInt(match[1], 10);
        }

        e.preventDefault();
        self.applyFilters(page);
      });
    });
  };

  PageCollectionGrid.prototype.bindCollectionSwitcher = function () {
    var self = this;
    this.section.querySelectorAll('.page-collection-grid__switcher-link[data-collection-url]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var url = link.getAttribute('data-collection-url');
        if (!url) return;
        if (!self.mixedMode && url === self.collectionUrl) return;
        self.mixedMode = false;
        self.setMixedViewState(false);
        self.collectionUrl = url;
        self.root.dataset.collectionUrl = url;
        self.resolvedSectionId = '';
        self.loadInitial({ scrollToGrid: true });
      });
    });
  };

  PageCollectionGrid.prototype.updateSwitcherActiveState = function () {
    var self = this;
    this.section.querySelectorAll('.page-collection-grid__switcher-link[data-collection-url]').forEach(function (link) {
      var isActive = !self.mixedMode && link.getAttribute('data-collection-url') === self.collectionUrl;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  function initSection(section) {
    if (!section || !section.classList.contains('page-collection-grid')) return;
    new PageCollectionGrid(section);
  }

  function init() {
    document.querySelectorAll('.page-collection-grid').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var section = event.target.classList.contains('page-collection-grid')
      ? event.target
      : event.target.querySelector('.page-collection-grid');
    if (section) initSection(section);
  });
})();
